// src/utils/validators.js
export const validateAmount = (amount) => {
  // Check if amount is empty or not a string/number
  if (amount === undefined || amount === null || amount === '') {
    return {
      valid: false,
      message: "Please enter an amount"
    };
  }

  // Check if amount is a valid number
  const parsedAmount = parseFloat(amount);
  if (isNaN(parsedAmount)) {
    return {
      valid: false,
      message: "Please enter a valid number"
    };
  }

  // Check if amount is positive
  if (parsedAmount <= 0) {
    return {
      valid: false,
      message: "Please enter a valid amount greater than 0"
    };
  }

  // Check if there are too many decimal places (for ETH transactions)
  if (amount.toString().includes('.')) {
    const decimalPlaces = amount.toString().split('.')[1].length;
    if (decimalPlaces > 18) {
      return {
        valid: false,
        message: "ETH can only have up to 18 decimal places"
      };
    }
  }

  return { valid: true };
};